<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K5Ctv/tc-custom/9780830891009.jpg?1696025000968" alt="This image is the cover for the book Daniel, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daniel, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>Daniel asserts that the meaning of history is that God's kingdom is coming. As it does, faithful people persevere in their work for God. Believers can rely on the certainties the book proclaims: God is sovereign over human affairs and is effectively bringing in his eternal kingdom, which will encompass all nations. In this Tyndale commentary, Paul House shows how Daniel rewards readers who embrace its historical, literary, and theological features as key means of personal and community formation. The Tyndale Commentaries are designed to help the reader of the Bible understand what the text says and what it means. The<em>Introduction</em> to each book gives a concise but thorough treatment of its authorship, date, original setting, and purpose. Following a structural <em>Analysis</em>, the <em>Commentary</em> takes the book section by section, drawing out its main themes, and also comments on individual verses and problems of interpretation. <em>Additional Notes</em> provide fuller discussion of particular difficulties. In the new Old Testament volumes, the commentary on each section of the text is structured under three headings:<em>Context</em>, <em>Comment</em>, and <em>Meaning</em>. The goal is to explain the true meaning of the Bible and make its message plain.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul R. House, David G. Firth, Tremper Longman III
      </h2>
      
      <p class="authorDescription body article"><p>Paul R. House teaches at Beeson Divinity School of Samford University (Birmingham, Alabama). An Old Testament scholar, he has taught previously at Taylor University, Southern Baptist Theological Seminary, and Wheaton College.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      IVP
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75b79849